var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",style:(_vm.style),attrs:{"id":_vm.uuid}})
}
var staticRenderFns = []

export { render, staticRenderFns }